<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl"><icon name="store-front" class="w-6 h-6 -mt-1 mr-2 inline-block" /> Listado de Experiencias</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" :show-filter="true" class="w-full max-w-md mr-4" @reset="reset">
      </search-filter>
      <inertia-link class="btn-indigo" :href="route('ads.create')">
        <span>Crear</span>
        <span class="hidden md:inline">Experiencia</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Titulo</th>
          <th class="px-6 pt-6 pb-4">Localidad</th>
          <th class="px-6 pt-6 pb-4">Link</th>
          <th class="px-6 pt-6 pb-4">Activado</th>
        </tr>
        <tr v-for="ad in ads.data" :key="ad.id" class="hover:bg-gray-100 text-sm focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center text-blue-500" :href="route('ads.edit', ad.id)">
               {{ ad.titulo }}
               <div v-if="ad.gastronomia" class="bg-yellow-500 p-1 text-xs ml-2   text-white text-center inline-block font-semibold rounded"><icon name="food" class="w-4 h-4 -mt-1 inline-block" />Gastronomia </div>

            </inertia-link>

            
          </td>
          <td class="border-t px-6">
              {{ ad.localidad }}
          </td>
           <td class="border-t px-6">
              {{ ad.link }}
          </td>
           <td class="border-t px-6 text-center">
              <span :class=" ad.publicado ? 'bg-green-500' : 'bg-red-500'"  class="w-4 h-4  inline-block rounded-full"></span>
          </td>
        </tr>
        <tr v-if="ads.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No se encontraron Experiencias.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="ads.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'Experiencia' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    ads: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('ads'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
